// Read the machine IP from the meta tag
const getMachineIpFromMeta = () => {
  const metaTag = document.querySelector('meta[name="machine-ip"]');
  return metaTag ? metaTag.getAttribute('content') : 'http://localhost:80801';
};

// Construct the API URL
const machineIp = getMachineIpFromMeta();
//export const API = machineIp ? `${machineIp}/api` : '';
export const API = "/api";  // Use it for any independent app
//export const API = "http://192.168.8.230:8081/api";  // use it for the app runining on linux server at el225
//export const API = "http://localhost:8081/api"; // run this for the app running at el225 and access remotely from home through vs code
//console.log('API URL:', API);
//export const API = "http://100.92.5.108:8081/api";  // Access remotely using tailscale

//export const API= "/api";  // Use in development mode
// use this api call when "proxy": "http://localhost:8080",  line get added into package.json of react app  
// Above line is get added hence, in development mode react app will make api call to backend on local host and end user will be able to access react app with below url
//http://192.168.3.10:3000/login
// "proxy": "http://localhost:8080",  Remove this line from package.json when production build is used and use nginx reverse proxy solution


//Below api calls for differnet kind of tesing
//export const API= "http://localhost:3000/api"; // use this when app should be accesble only through local machine only.
//export const API = "http://192.168.3.10:3000/api";  //where 192.168.3.10 is the local machine ip where node and react app are running.
//export const API = "https://114.79.137.43/api"   // as per nginx conf need to use this link
//export const API = "https://webapp.radix.biz:443/api"  //use it when https request used from remote machine
//export const API = "http://webapp.radix.biz:80/api"  //use it when http request used from remote machine
